import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * usePremiumEnabled — reads the admin master toggle
 * (settings_flags.subscription_enabled) so UI elements can hide Premium
 * badges / paywall CTAs when subscriptions are globally disabled.
 * Returns `true` when the admin has enabled paid subscriptions.
 */
export function usePremiumEnabled() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let mounted = true;
    const load = () => {
      axios.get('/api/subscription/settings')
        .then(r => { if (mounted) setEnabled(!!r.data?.enabled); })
        .catch(() => { if (mounted) setEnabled(false); });
    };
    load();
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);
    return () => {
      mounted = false;
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onFocus);
    };
  }, []);
  return enabled;
}
